import { ref } from 'vue';
import { appLocale } from 'shared';

import { debugEntityLib } from './lib';
import type { DebugState } from './types';

const defaultState: DebugState = {
  isDevAuth: false,
  isDebugBarVisible: true,
  language: appLocale.config.locales.RU,
};

const isStrTrue = (str: string) => str === 'true';

// TODO: Add tests
export const useDebugState = () => {
  const debugStateStorage = debugEntityLib.initStateStorage();
  const state = ref(defaultState);

  const setStateToSearchParams = () => {
    const searchParams = new URLSearchParams(window.location.search);

    (Object.keys(state.value) as Array<keyof DebugState>).forEach(key =>
      searchParams.set(key, String(state.value[key])),
    );

    return searchParams.toString();
  };

  const updateState = (updatedState: Partial<DebugState>) => {
    state.value = {
      ...state.value,
      ...updatedState,
    };

    const newStateParams = setStateToSearchParams();
    /**
     * @note
     * Need to slice "?" at the beginning
     */
    const shouldChangeParams =
      window.location.search.slice(1) !== newStateParams;
    if (shouldChangeParams) {
      debugStateStorage.set(state.value);
      window.location.search = newStateParams;
    }
  };

  const init = () => {
    const searchParams = new URLSearchParams(window.location.search);
    /**
     * We always check query params first and if they are missed we try to get params from the storage
     */
    const isDevAuth =
      searchParams.get('isDevAuth') || debugStateStorage.get('isDevAuth');
    const isDebugBarVisible =
      searchParams.get('isDebugBarVisible') ||
      debugStateStorage.get('isDebugBarVisible');

    state.value = {
      isDevAuth: isDevAuth ? isStrTrue(isDevAuth) : defaultState.isDevAuth,
      isDebugBarVisible: isDebugBarVisible
        ? isStrTrue(isDebugBarVisible)
        : defaultState.isDebugBarVisible,
      language: appLocale.lib.getAppLocale(defaultState.language),
    };
  };

  init();

  return {
    state,
    init,
    updateState,
  };
};
